export default {
  route: {
    homePage:'Homepage',
    dataDisplay:'Data display',
    atlas:'Map',
    journal:'Log',
    details:'Details',
    systemSetting: "System Settings",
    loginAccount: 'Account Management',
    merchants: 'Merchant Management',
    devices: "Device Management",
    material: "Material Management",
    deviceConfig: "Device Configuration",
    configProfileLibrary: "Profile library",
    configBindDispatch: "Bind & dispatch",
    leoKnowledgeGroup: 'Leo Knowledge',
    leoKnowledgeModelFields: 'Model knowledge fields',
    leoKnowledgeEquipmentTypeTypeKey: 'Equipment type type_key',
    leoKnowledgeUpload: 'Knowledge upload',
    leoKnowledgeIngestBatch: 'Ingest batch (auto)',
    leoKnowledgePhase1Ssot: 'Phase1 SSOT pipeline',
    leoKnowledgeCapabilityMatrix: 'Capability matrix',
    leoKnowledgeOnboarding: 'Smart model onboarding',
    leoKnowledgeTesterConsole: 'Tester console',
    leoKnowledgePipelineHub: 'Pipeline hub',
    leoKnowledgeFeatureSurface: 'Feature → API map',
    leoKnowledgeProtocolDoc: 'Protocol doc index',
    leoKnowledgeRemoteTools: 'Remote tool catalog',
    leoKnowledgeLearning: 'Learning loop',
    leoKnowledgeExternalIngest: 'External knowledge ingest',
    leoKnowledgePortalHub: 'Leo console & portal',
    leoKnowledgePortalHubDesc: 'Open Leo sovereign console, mobile portal, and Leo / LeoSmart chat in a new tab—separate from Profile workbench for a stable entry.',
    leoKnowledgePortalHubHint: 'Console uses the bubble chat layout; portal is the lightweight entry. Add portalToken / ceoBearer in the URL after opening if needed.',
    leoKnowledgeUiSurfaceSample: 'Admin UI sample (soft gray canvas)',
    uiSurfaceSampleLead: 'Demonstrates a light gray page canvas with white cards for filters, tables, and KPIs—easier on the eyes than a full white viewport. If you like it, we can promote the tokens globally.',
    uiSurfaceSampleAlert: 'Visual mock only: form controls and table rows are fake data and do not call the backend.',
    uiSurfaceSampleKpi_orders: 'Orders today (mock)',
    uiSurfaceSampleKpi_online: 'Devices online',
    uiSurfaceSampleKpi_alerts: 'Open alerts',
    uiSurfaceSampleKpiSub: 'Sample figures',
    uiSurfaceSampleFilterTitle: 'Filters (white card)',
    uiSurfaceSampleKeyword: 'Keyword',
    uiSurfaceSampleKeywordPh: 'Name or code',
    uiSurfaceSampleStatus: 'Status',
    uiSurfaceSampleStAll: 'All',
    uiSurfaceSampleStOn: 'On',
    uiSurfaceSampleStOff: 'Off',
    uiSurfaceSampleReset: 'Reset',
    uiSurfaceSampleSelectPh: 'Select',
    uiSurfaceSampleTableTitle: 'List mock (white card + table)',
    uiSurfaceSampleColName: 'Name',
    uiSurfaceSampleColRegion: 'Region',
    uiSurfaceSampleColStatus: 'Status',
    uiSurfaceSampleColUpdated: 'Updated',
    uiSurfaceSampleCompareTitle: 'Contrast: flat white vs layered gray',
    uiSurfaceSampleCompareOld: 'Old feel: large white slab',
    uiSurfaceSampleCompareOldDesc: 'When content and background are both bright white, edges blur and long reads feel harsher.',
    uiSurfaceSampleCompareNew: 'Proposed: white cards on gray',
    uiSurfaceSampleCompareNewDesc: 'Primary content stays on white for contrast; the page uses a soft gray field so the eye can rest.',
    leoPortalHubSovereign: 'Console (fullscreen)',
    leoPortalHubPortal: 'Portal',
    leoPortalHubDeviceIntegrationSection: 'Device integration',
    leoPortalHubDeviceIntegrationLink: 'Public docs & tools (new tab)',
    leoPortalHubRuntimeModuleLink: 'Device cloud runtime AAR (new tab)',
    leoPortalHubSdkLabSection: 'XRROSS SDK (engineering)',
    leoPortalHubSdkEngineerLabOpen: 'Full test bench (track 1 + 2, new tab)',
    leoPortalHubSdkPublicTrack1: 'Track 1 public page',
    leoPortalHubSdkPublicTrack2: 'Track 2 public page',
    leoPortalHubChatSection: 'Chat entry',
    leoPortalHubPreferences: 'My preferences',
    leoPortalHubLogin: 'Sign in',
    leoPortalHubSectionOps: 'Operations console',
    leoPortalHubSectionOpsDesc: 'Live chat stream and CEO / portal sovereign view—best on a large display.',
    leoPortalHubSectionPortal: 'Mobile portal',
    leoPortalHubSectionPortalDesc: 'Lightweight entry for phones or demos.',
    leoPortalHubSectionChat: 'Conversational AI',
    leoPortalHubSectionChatDesc: 'Classic Leo vs LeoSmart (second workflow). Preferences and sign-in below.',
    leoPortalHubSectionDeviceDesc: 'Public docs, runtime module, and integration material (all open in a new tab).',
    leoPortalHubSectionSdkDesc: 'Engineering bench for dual-track wiring, regression, and debugging.',
    leoPortalHubCardSovereignDesc: 'Bubble chat, Markdown, and SOP step cards.',
    leoPortalHubCardPortalDesc: 'Compact Leo portal; add portalToken / ceoBearer in the URL when needed.',
    leoPortalHubCardLeoDesc: 'Default surface for day-to-day operations and knowledge Q&A.',
    leoPortalHubCardLeoSmartDesc: 'Uses conversation surface leosmart with the second Dify workflow.',
    leoPortalHubCardPrefDesc: 'Persona, locale, and personalization.',
    leoPortalHubCardLoginDesc: 'Sign in with a staff account before using write or sensitive actions.',
    leoPortalHubCardDeviceIntegrationDesc: 'Public narrative, Track 1 tools, and integration checklist.',
    leoPortalHubCardRuntimeDesc: 'Device cloud runtime / AAR and Track 2 entry point.',
    leoPortalHubCardSdkLabDesc: 'Integrated lab to exercise Track 1 and Track 2 together.',
    leoPortalHubSdkFeaturedTag: 'Engineering',
    leoPortalHubOpenNewTab: 'Open in new tab',
    leoPortalHubSdkCrossRefHint: 'For Track 1 / Track 2 public pages, use the two cards under Device integration above.',
    leoFloatDockTitle: 'Leo (floating)',
    leoFloatDockMinimize: 'Minimize',
    leoFloatDockClose: 'Close',
    leoFloatDockResizeHint: 'Drag the bottom-right corner to resize',
    leoFloatDockSwitchLabel: 'Floating Leo chat',
    leoFloatDockSwitchHint: 'When on, a docked chat stays on top (drag the title bar). It hides on standalone Leo / Console / portal pages to avoid overlap.',
    layoutThemeUseDark: 'Switch to dark theme',
    layoutThemeUseLight: 'Switch to light theme',
    leoProfileWorkbenchLeoMovedPrefix: 'C-Line · Leo: console, portal, and Leo / LeoSmart chat moved under Leo Knowledge →',
    leoProfileWorkbenchLeoMovedSuffix: '.',
    equipmentCategory: 'Equipment category',
    equipmentCategoryEdit: 'Equipment category — edit',
    equipmentCategoryDel: 'Equipment category — delete',
    equipmentTypePermAdd: 'Equipment type — list/add',
    equipmentTypePermEdit: 'Equipment type — edit',
    deviceSimulatorConsole: 'Simulator console',
    leoDeviceOpsRolePolicy: 'Command permission matrix',
    leoDeviceOpsSemanticTraining: 'Semantic training workbench',
    leoKnowledgePortalOpsInventory: 'Portal ops API inventory',
    leoKnowledgePortalOpsDailyHub: 'PORTAL_OPS workbench',
    leoDeviceOpsReviewInbox: 'B-line review inbox',
    leoDeviceOpsDescriptionAutogen: 'Device_OPS workbench',
    leoDeviceOpsBLineDailyHub: 'B-line daily hub',
    simulatorGroup: 'Simulator',
    x600hGateway: 'X600H Gateway',
    xt90c2Simulator: 'XT90C2',
    blenderSimulator: 'Blender',
    productCenter: "Product Management",
    dataCenter: "Data Center",
    maintenance: "Operations management",
    filesCenter: 'File Management',
    menuSetting: 'Menu Settings',
    organization: 'User organization',
    loginAccount: 'Account List',
    authorization: 'Role Management',
    merchants: 'Merchant List',
    deviceList: 'Device List',
    channelCategory: 'Channel type',
    productCategory: 'Product Type',
    optionCategory: 'Specification Type',
    optionList: 'Specification List',
    storeAccount: 'Store Account',
    stores: 'Store Management',
    modelName: 'Device Name/Model',
    category: 'Material Type',
    configDistribute: 'Channel distribution',
    devicesChannels: 'Device Channels',
    productsList5: 'Product List 5',
    menuDistribute: 'Menu distribution',
    storeMenu: 'Store Menu',
    merchantData: 'Merchant Statistics Data',
    devicsData: 'Device Statistics Data',
    productionData: 'Equipment Production Data',
    maintanenceData: 'Equipment after-sales data',
    devicesWorkingData: 'Device Usage Data',
    afterSalesReminder: 'After sales Reminder',
    maintenanceTips: 'Maintenance Tips',
    fileUpgrade: 'File Upgrade',
    dataDowloan: 'Data Download',
    materialList: 'Material List',
    accessoriesCategory: 'Snack Types',
    accessoriesList: 'Snack List',
    businessCenter: 'Business Center',
    appsBanner: 'App Banner Display',
    advertisement: 'Advertisement List',
    advertBind: 'Advertisement Binding',
    advertDistribute: 'Advertising distribution',
    membersCenter: 'Membership List',
    orderCenter: 'Order List',
    packBag: 'Packaging bag',
    appsCenter: 'app management',
    productsList2: 'Product List 2',
    XTSeriesData: 'Batching Machine Data',
    productionData: 'Production Data',
    materialDate: 'Material Data',
    qualityData: 'Single cup data',
    alertsLog: 'Fault Log',
    cleaningLog: 'Cleaning Record',
    coffeeData: 'Coffee Machine Data',
    coffeeSumData: 'Quality Data',
    taxCenter: 'Tax Center',
    taxManagement: 'Tax Management',
    taxAllocation: 'Tax Allocation',
    dataOfTeaExtractorMachine: 'Tea Extraction Machine Data',
    dataOfBlendExtractorMachine:'Ice Sand Machine Data',
    dataOfMilkExtractorMachine:'Milk Frother Data',
    beverageOutputData: 'Production Data',
    singleCupData: 'Single cup data',
    faultLog: 'Fault Log',
    deliveryPlatform: 'Delivery Platform',
    uber:'Uber',
    otherProducts: 'Other products',
    listOfTeaExtractsProducts: 'List of Tea Extracts',
    machineDebug: 'Device Debugging',
    presetCommand:'Preset Command',
    commandConfiguration:'Command Configuration',
    operationAndMaintenanceServices:'Operation and maintenance services',
    productionList:'Production list',
    smallMaterial:'Small material list',
    takeoutProducts:'Takeout products',
    pointRule:'Points Rules',
    couponManagement:"Coupon Management",
    couponList:"Coupon List",
    additionalProducts:'Additional products',
    type:'Type',
    taxAllocation:'Tax Allocation',
    produce:'Products',
    produceList4:'Product List 4',
    smoothieMakerProduct:'Produced By Ice Sand Machine',
    machineMenu:'Equipment Menu',
    systemLog:"System log",
    region:'Region'
  },
  acoount: {
    name: '名称',
    enterpriseName: 'Merchant name',
    account: 'Account',
    password: 'Password',
    confirmPassword: 'Confirm password',
    roleTitle:'Permission title',
    roleName:'Permission name',
    phone:'Cell Phone',
    email:'Email',
    idNumber:'ID No.',
    workAddress:'Work Address',
    status:'Status',
    onDuty:'Normal',
    leaveDuty:'Resign',
    takeVacationrm:'Vacation',
    disable:'Disable',
    profilePicture:'Avatar',
    confirmPasswordCannotBeEmpty:'Password cannot be empty',
    inconsistentPasswordInput:'Inconsistent password inputs',
    emailFormatError:'Email error',
    phoneNumberFormatError:'Cell phone number error',
    notes:'Remark',
    empower:'Authorize',
    contactInformation:'Contact information',
    userOrganizationType:'Organization type',
    userOrganizationName:'Organization name',
    describe:'Description',
    available:'Available',
    deactivate:'Suspend',

  },
  merchant: {
    account: 'Login account',
    password: 'Password',
    store: 'Store',
    status:'Status',
    available:'Normal',
    deactivate:'Suspend',
    merchantName:'Merchant name',
    businessLicense:'Business License',
    frontIDCard:'Legal person ID card front',
    backIDCard:'Legal person ID card back',
    head:'Principal',
    Telephone:'Contact number',
    userOrganization:'Organization',
    businessAddress:'Registration Address',
    trade:'Open',
    closeBusiness:'Closed',
    superior:'Superior',
    supervisorSubordinateRelation:'Organization chat',
    clickView:'Click to view',
    business:'Merchant',
    country:'Country',
    address:'Address',
    shopNames:'Store name',
    storeType:'Store type',
    selfService:'Self-service',
    askFor:'Pick up',
    SelfPickupTakeoutShop:'self-service+takeaway',
    selfServicePickUpTakeout:'self-service+takeaway+Delivery',
    businessHours:'Business hours',
    closingTime:'Closing time',
    operatingCycle:'Business cycle',
    Monday:'Monday',
    Tuesday:'Tuesday',
    Wednesday:'Wednesday',
    Thursday:'Thursday',
    Friday:'Friday',
    Saturday:'Saturday',
    Sunday:'Sunday',
    picture:'Photo',
    vatNumber:'VAT增值税号',
    kvtCompanyRegistrationNumber:'KVK公司注册号',
    invoiceUnifiedNumbering:'Invoice unified number',
    invoiceAccountNumber:'Invoice account number',   
    POSAPIKey:'POS API Key',
    POSAccount:'POS Account',
    APPAPIKey:'APP API Key',
    APPAccount:'APP Account',
    APPClientKey:'APP Client Key',
    region:'Region'

  },
  device:{
    deviceType:'Device type',
    totalDevice:'All devices',
    offLineDevice:'Offline',
    materialShortageDevice:'Material Shortage',
    alertingDevice:'Alarm',
    lockDevice:'Locked',
    passConfigName:"Name",
    maintenanceDevice:'Needs Maintenance',
    businessInformation:'Business information',
    deviceId:'Name',
    deviceModel:'Model No.',
    modelCodeKey:'Model code (Leo model_key)',
    modelCodePlaceholder:'e.g. PT5 or XRROSS_PT5; must be unique',
    modelCodeRequired:'Please enter model code (Leo model_key)',
    dealer:"Retailer",
    deviceImie:'ID',
    equipmentSerialNumber:'S/N',
    posNumber:'Credit card machine SN',
    store:'Store',
    location:'Device location',
    none:'None',
    log:"Log",
    fault:"Defective",
    normal:"Normal",
    offline:"Offline",
    onLine:"Online",
    isFault: "Defective",
    type:"Type",
    fullyAutomatic:"Fully automatic",
    semiAutomatic:"Semi-automatic",
    availableMerchants:"Available merchants",
    faultStatistics:"Defects Statistics",
    basicMaintenance:"Basic Maintenance",
    deepMaintenance:"Deep maintenance",
    onLineDevice:'Online device',
    equipmentOnlineStatus: "Equipment status:",
    brandName: "Brand name:",
    telephone: "Telephone:",
    equipmentModelName: "Equipment model/name:",
    dateOfManufacture: "Date of manufacture:",
    usageDate: "Date of use:",
    menu: "Menu",
    productName : "Product name",
    channelConfiguration : "Channel configuration",
    channelNumber : "Channel number",
    material : "Material",
    shelfLife : "Shelf life",
    alarmListForTheDay: "Alarm list (for the day)",
    content : "Content",
    time : "Time",
    key: "Key",
    frequency : "Number of times",
    remoteOperation : "Remote operation",
    success : "Success",
    menuStatus: "Menu status",
    updated: "Updated",
    notUpdated: "Not updated",
    lock: "Lock",
    unlock: "Unlock",
    startup: "Startup",
    shutdown: "Shutdown",
    restart: "Restart",
    param: "Param",
    factoryParam: 'Factory Param',
    moduleParam: 'Module Param',
    paramBaselineOpen: 'Parameters',
    paramBaselineTitle: 'Parameter baseline (Leo / model)',
    paramBaselineHint: 'Use the same JSON path as device config (e.g. config.stirTime). Used by Leo to compare with live machine config.',
    paramBaselineAddRow: 'Add row',
    paramBaselineSave: 'Save',
    paramBaselineRefresh: 'Reload',
    paramKey: 'Param key',
    paramKeyPh: 'e.g. config.stirTime',
    paramDisplayName: 'Display name',
    standardValue: 'Standard value',
    lowerLimit: 'Lower',
    upperLimit: 'Upper',
    unit: 'Unit',
    paramRemark: 'Remark',
    paramBaselineNoProfile: 'No readable L1 profile (or no PUBLISHED version) for this model. Create/publish a profile bound to this model in Profile management first.',
    paramBaselineProfileSource: 'Default source: {name} · published #{version}',
    paramBaselineApplyPublished: 'Apply from latest published',
    paramBaselineApplyConfirm: 'Merge suggested keys/values from the latest published JSON (overwrite same keys). Continue?',
    paramBaselineApplyDone: 'Merged published suggestions (review and save)',
    paramBaselineTypeUnionTitle: 'Same equipment type · union of paths from latest published (reference)',
    paramBaselineTypeUnionMissing: 'Model IDs without profile',
  },
  produce: {
    name: 'Name',
    price: 'Price',
    matterType: 'Material type',
    normType: 'Option type',
    matter: 'Material',
    min: 'Minimum value',
    max:'Maximum value',
    shelfLife:'Expiry Time',
    unit:'Unit',
    hour:'Hour',
    step1:'Product information',
    step2:'Product material',
    step3:'Product recipe',
    step4:'Recipe combination',
    step5:'Product accessories',
    produceName:'Product name',
    produceCode:'Code',
    produceType:'Product type',
    showSnacks:'Show snacks',
    yes:'Yes',
    no:'No',
    describe:'Description',
    order:'Order',
    value:'Value',
    unit:'Unit',
    norm:'Options',
    select:'Select',
    step:'Step',
    matterSequence:'Material sequence',
    action:'Action',
    freeSnacks:'Free Options',
    feeBasedMaterials:'Charged Options',
    nextStep:'Next',
    back:'Back',
    save:'Save',
    saveUpdate:'Save update',
    productList:'Product list',
    selectProduct:'Select product',
    menuSort:'Sort',
    produceImport:'Export',
    bind:'Binding',
    bindMachien:'Bind Device',
    smallMatterType:'Accessories type',
    listing:'Listing',
    productListName:"Enter the name of the production menu",
    Text1: 'Enter the product name',
    Text2: 'Merchant',
    Text3:'Material',
    Text4:'Small material',
    Text5:'Drink',
    Text6:'Snacks',
    Text7:'New recipes',
    Text8:'Update',
    Text9:'This product code already exists',
    Text10:'Please complete the product information',
    Text11:'Tea',
    Text12:'First paragraph',
    Text13:'Second paragraph',
    Text14:'Third paragraph',
    Text15:'Out',
    Text16:'Not out',
    Text17:'Range:',
    Text18:'Amount of tea:',
    Text20:'Amount of ice:',
  },
  business: {
    name: 'Name',
    type: 'Type',
    homepage: 'Homepage',
    advertisingList: 'Advertising list',
    pictureOrVideo: 'Photo/video',
    addProductAdvertisements:'Add product advertisements',
    AddImagesOrvideos:'Add new photo/videos',
    userName: 'Username',
    email: 'Email',
    sex: 'Gender',
    birthday: 'Birthday',
    phone: 'Cell phone number',
    walletBalance: 'Wallet balance',
    integral: 'Member points',
    orderNo: 'Order number',
    pickupCode: 'Pickup code',
    store: 'Store',
    amount: 'Order amount',
    payAmount: 'Actual payment amount',
    receiptsPrice: 'Actual amount received',
    discount: 'Discount',
    orderStatus: 'Order status',
    toBePaid: 'Waiting Payment',
    paid: 'Paid',
    processing: 'Processing',
    completed: 'Completed',
    orderCancellation: 'Order Cancelled',
    orderRejection: 'Order rejected',
    paymentMethod: 'Payment type',
    wallet: 'Wallet',
    cash: 'Cash',
    pos: 'Card machine',
    produce: 'Produce',
    unitPrice: 'Unit price',
    number: 'Number',
    parameter: 'Parameter',
    totalTaxAmount:'Total tax amount',
    orderType: 'Order type',
    pack: 'Pack',
    dineIn: 'Dine-in',
    taxName:'Tax name',
    taxAmount:'Tax amount',
    taxRate:'Tax rate',
  
  },
  operation:{
    orderAmount:"Order amount",
    orderQuantity:"Order quantity",
    actualAmountReceived:"Actual amount received",
    top_10_beverage_rankings:"Top 10 Beverage Rankings",
    sales_revenue:"Sales revenue",
    order_quantity:"Order quantity",
    payment_method:"Payment method",
    real_time_orders_on_the_hour:"Real time orders on the hour",
  },
  dataCenter:{
    Text1: "Content",
    Text2: "Data",
    Text3: "Sales volume/cup",
    Text4: "Sales revenue/yuan",
    Text5: "Consumable materials/g",
    Text6: "Month",
    Text7: "Day",
    Text8: "Hour",
    Text9: "Chart",
    Text10: "Material consumption per cup",
    Text11: "Ranking",
    Text12: "Production Consumption Materials",
    Text13: "Equipment Consumption Materials",
    Text14: "Percentage",
    Text15: "Ranking",
    Text16: "Sales Volume",
    Text17: "Sales revenue",
    Text18: "Time/Cup",
    Text19: "Product sales volume",
    Text20: "Product sales revenue",
    Text21: "Device sales volume",
    Text22: "Equipment sales revenue",
    Text23: "Total cup volume",
    Text24: "Total formula amount/gram",
    Text25: "Actual total formula quantity/gram",
    Text26: "Bad cup quantity/cup",
    Text27: "Bad cup rate/%",
    Text28: "Error rate/%",
    Text29: "Product Name",
    Text30: "Production method",
    Text31: "Scan Code",
    Text32: "Product",
    Text33: "Manual",
    Text34: "Order number",
    Text35: "Store",
    Text36: "Unit Price",
    Text37: "Total amount of formula (g)",
    Text38: "Actual cup output (g)",
    Text39: "Cup out time",
    Text40: "Error (%)",
    Text41: "Bad Cup",
    Text42: "Normal",
    Text43: "Production completed",
    Text44: "Production failed",
    Text45: "Completion time",
    Text46: "Mode",
    Text47: "Channel",
    Text48: "Status",
    Text49: "Incomplete",
    Text50: "Completed",
    Text51: "Product Name",
    Text52: "Number of Cups",
    Text53: "Total price",
    Text54: "Order Statistics",
    Text55: "Order List",
    Text56: "Order Amount",
    Text57: "Order quantity",
    Text58: "Actual amount received",
    Text59: "Product amount",
    Text60:"Tea quantity",
    Text61: "Water output",
    Text62: "Sales volume/barrel",
    Text63: "Bucket",   
    Text64: "Sour/Extraction too short",
    Text65: "Balanced/Extraction moderate",
    Text66: "Bitter/Extraction too much",
    Text67: "Bitter/Low concentration",
    Text68: "Moderate",
    Text69: "Strong/High concentration",
    Text70:"Extraction time",
    Text71:"Water-powder ratio",
    strongBalance:"Strong balance",
    weakBalance:"Weak balance",
    mediumAcid:"Medium acid",
    strongAcid:"Strong acid",
    goldenCup:"Golden cup",
    weakAcid:"Weak acid",
    bitter:"Bitter",
    strongBitter:"Strong bitter",
    weakBitter:"Weak bitter",  
    extractionTime:"Extraction time",    
    Text72:"Dynamic calibration",    
    },
    taxation:{
      Text1:"Tax name",   
      Text2:"Tax rate",   
      Text3:"Cardinal number", 
      Text4:"Remarks", 
      Text5:"Country", 
      Text6:"Type", 
      Text7:"Dine in",  
      Text8:"Packaging",   
      Text9:"Product Type",
      Text10:"Tax Type", 
      Text11:"Platform Takeaway",             
    },
  pass: {
    name: 'Name',
    pass: 'Channel',
    passNumber: 'Channel number',
    preDischargeTime: 'Channel filling time',
    addPass:'Add new channel',
    bindPass:'Channel binding',
    passConfigName:'Channel configuration name'
  
  },
  uber:{
    Text1: "Uber Store",
    Text2: "Platform Store",
    Text3: "Menu Status",
    Text4: "Store Status",
    Text5: "Already bound",
    Text6: "Unbound",
    Text7: "Synchronization"
    },
  login: {
    title: 'System login',
    logIn: 'Login',
    username: 'Account',
    password: 'Password',
    readAndAgree:'Read and Agree',
    pleaseCheckThePrivacyAgreement:'Please confirm the privacy agreement',
    termTip:'<<Privacy Agreement>>',
     Text1:'请输入账号',
    Text2:'请输入密码'


  },
  navbar: {
    logOut: 'Log out',
    dashboard: 'Homepage',
    github: 'Project address',
    screenfull: 'Full screen',
    theme: 'Skin changing',
    size: 'Layout size'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close all'
  },
  common: {
    tower: 'tower',
    yuan: '$',
    cup: 'Cup',
    place: 'Place',
    individual: 'Individual',
    language: 'Language',
    success: 'Successful',
    fail: 'Failed',
    createTime: 'Creation time',
    all: 'All',
    common:'All',
    sureDel: 'Confirm deletion',
    tip: 'Hint',
    status: 'Status',
    bing: 'Binding',
    pleaseSelectDevice: 'Please select a device',
    pleaseSelectMenu:'Please select a menu',
    pleaseSelectModel: 'Please select a model',
    pleaseSelect: 'Please select',
    code: 'Code',
    entering_the_platform:'Entering the platform',
    date:"Date",
    address_fail:"The address is incorrect",
    back:'Back',
    pleaseEnter:'Please enter',
    uploadImageBtn:'Click to upload an image',
    uploadImageBtnTip:'Only supports uploading JPG and PNG formats (limited to 10M)',
    uploadVideoBtn:'Click to upload a video',
    uploadVideoBtnTip:'Only supports uploading mp4 or MP4 files (limited to 50M)',
    videoPlayTip:' Your browser does not support video playback'

  },
  table: {
    search: 'Query',
    detail: 'Details',
    actions: 'Actions',
    edit: 'Edit',
    publish: 'Publish',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'OK',
    add: 'Add',
    copy: 'Copy',
    produceCodeRule:'Coding Rules',
    batchDeletion: 'Batch deletion',
    batchImport: 'Batch Import',
    batchCopy:'Batch Copy',
    export: 'Data export',
    import: 'Import',
    templateDownload: 'Template Download',
    dragAndDropUpload: 'Drag the file here, or click on upload',
    picture: 'Picture',
    resetPwd:'Reset Password'

  },
  coffeeData:{
    Text1: "Immersion flow rate",
    Text2: "Soaking time",
    Text3: "Extraction flow rate",
    Text4: "Extraction pressure",
    Text5: "Extraction temperature",
    Text6: "Order Type",
    Text7: "Status",
    Text8: "Cup time",
    Text9: "Powder Quantity",
    Text10: "Device Encoding",
    Text11: "Product Name",
    Text12:"Coffee Liquid", 
    Text13: "Powder pressing force",
    Text14: "Powder cake thickness",
    Text15: "Extraction flow rate",
    Text16: "Extraction chamber position",  
    Text17: "Grinding degree 1",
    Text18: "Grinding degree 2",  
     
    }
}


// WEBPACK FOOTER //
// ./src/lang/en.js